<template>
  <div class="el-tabs-container">
    <el-tabs v-model="tab_index">
      <el-tab-pane label="SEI客户">
        <span slot="label">{{$t("tab.tab_sei_customer")}}</span>
        <CustTableSEI></CustTableSEI>
      </el-tab-pane>
      <el-tab-pane label="客户">
        <span slot="label">{{$t("tab.tab_customer")}}</span>
        <CustTable></CustTable>
      </el-tab-pane>
      <!-- <el-tab-pane label="绑定员工">
        <span slot="label">绑定员工</span>
        <CustTableSEIBindUser></CustTableSEIBindUser>
      </el-tab-pane> -->
    </el-tabs>
  </div>
</template>

<script>
import CustTableSEI from "./CustTableSEI";
// import CustTableSEIBindUser from "./CustTableSEIBindUser";
import CustTable from "./CustTable";

export default {
  name: "CustTableMain",
  components: {
    CustTableSEI,
    CustTable,
    // CustTableSEIBindUser
  },
  data() {
    return {
      tab_index: 0
    };
  },
  created() { },
  methods: {}
};
</script>
